import MicroModal from "micromodal";

class MicroModalWindow {
  constructor() {
    this.pageElement = document.getElementById("js-page");
    this._microModalInit();
  }

  _microModalInit() {
    MicroModal.init({
      disableScroll: true,
      onShow: (modal) => {
        this._addOpenClass();
      },
      onClose: (modal) => {
        this._removeOpenClass();
      },
    });
  }

  _addOpenClass() {
    this.pageElement?.classList.add("js-modal-open");
  }

  _removeOpenClass() {
    this.pageElement?.classList.remove("js-modal-open");
  }
}

export default MicroModalWindow;
